import { useEffect, useState } from 'react';
import { api } from './api';
import { EmptyState } from './EmptyState';

interface Task {
  task_id: number; title: string; description: string | null;
  start_time: string; end_time: string | null; location: string | null;
  completed: boolean; assigned_by_name: string;
  comments?: { comment_id: number; employee_name: string; content: string }[];
}
const date = (value: string) => new Date(value).toLocaleString('de-DE');

export function TasksPage({ employeeId, onBack }: { employeeId: number; onBack: () => void }) {
  const [tasks, setTasks] = useState<Task[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [reload, setReload] = useState(0);
  const [completed, setCompleted] = useState(false);
  useEffect(() => {
    let active = true;
    let running = false;
    async function load() {
      if (running) return;
      running = true;
      try {
        const result = await api<Task[]>(`/tasks?employee_id=${employeeId}`);
        if (!Array.isArray(result)) throw new Error('Ungültige Aufgabenliste');
        if (active) { setTasks(result); setError(''); }
      } catch (reason) {
        if (active) setError(reason instanceof Error ? reason.message : 'Aufgaben konnten nicht geladen werden.');
      } finally { running = false; if (active) setLoading(false); }
    }
    setTasks([]); setLoading(true); void load();
    const timer = window.setInterval(load, 30000);
    window.addEventListener('focus', load); window.addEventListener('online', load);
    return () => { active = false; window.clearInterval(timer); window.removeEventListener('focus', load); window.removeEventListener('online', load); };
  }, [employeeId, reload]);
  const visible = tasks.filter(task => task.completed === completed);
  return <div className="page"><div className="page-heading"><h1>Meine Aufgaben</h1><button className="button secondary" onClick={onBack}>Zurück</button></div>
    <div className="chip-list"><button className={`chip ${!completed ? 'selected' : ''}`} onClick={() => setCompleted(false)}>Offen ({tasks.filter(task => !task.completed).length})</button><button className={`chip ${completed ? 'selected' : ''}`} onClick={() => setCompleted(true)}>Erledigt ({tasks.filter(task => task.completed).length})</button><button className="chip" onClick={() => setReload(value => value + 1)}>Aktualisieren</button></div>
    {loading && <p role="status">Aufgaben werden geladen …</p>}
    {error && <div className="alert error" role="alert">Aufgaben konnten nicht geladen werden: {error}</div>}
    {!loading && !error && visible.length === 0 && <EmptyState icon="report" title={completed ? 'Keine erledigten Aufgaben' : 'Keine offenen Aufgaben'}>Hier erscheinen die dir zugewiesenen Aufgaben.</EmptyState>}
    <div className="cards">{visible.map(task => <article className="plan-card" key={task.task_id}><h2>{task.title}</h2>{task.description && <p style={{whiteSpace:'pre-wrap'}}>{task.description}</p>}<dl><div><dt>Beginn</dt><dd>{date(task.start_time)}</dd></div>{task.end_time && <div><dt>Ende</dt><dd>{date(task.end_time)}</dd></div>}{task.location && <div><dt>Ort</dt><dd>{task.location}</dd></div>}<div><dt>Zugewiesen von</dt><dd>{task.assigned_by_name}</dd></div></dl>{task.comments?.map(comment => <p key={comment.comment_id}><strong>{comment.employee_name}: </strong>{comment.content}</p>)}</article>)}</div>
  </div>;
}
